<template lang="pug">
  div
    doc-markdown(source=`
    ## Flash \`sw-flash\`
    Used to display error or success messages to the user in the form of a wide coloured banner popping up at the top of the page.

    Note that we currently use two kinds of Flash message components:
    - This one, used in our VoR purchase processes. Feeded directly from the Vue code.
    - \`TheFlashMessages\`, used in our Rails layouts. Feeded from the Rails backend.

    They're not to be confused at their usage is different (although complementary). The first one is to be used inside our fully-embedded Vue apps, where the second one is used in Rails layouts and is triggered by the classic Rails \`flash[:alert] = 'error message'\` syntax in the controller.
    `)

    doc-preview(vue=`
    sw-flash(:show.sync="errorToDisplay" error) This is the Flash text
    `)
      sw-flash(:show.sync="errorToDisplay" error) This is the Flash text


    doc-markdown(source=`
    ### Slots
  | Slot name      | Description                                        |
  |----------------|----------------------------------------------------|
  | *default*      | The text that is displayed in the flash banner.    |

    ### Properties
    Note that the \`show\` prop (that decides if a flash message should be shown) is passed from the parent, but will be updated from inside \`SwFlash\` after a few seconds timeout. Thus the \`.sync\` syntax allowing the child -> parent communication.
  | Props                     | Description                                                                   | Type    | Default             |
  |---------------------------|-------------------------------------------------------------------------------|---------|---------------------|
  | \`show\`                  | Whether a Flash message must appear or not.                                   | Boolean | false               |
  | \`error\` or \`success\`  | Red background will be displayed with \`error\`, a green one with \`success\`.| Boolean | false               |
    `)
</template>

<script>
export default {
  data () {
    return {
      errorToDisplay: true,
    };
  },
};
</script>
